<app-item class="rounded-border-box" [class.active]="!readOnly" (click)="controlClicked($event)">
	<app-item-label class="no-events validation-label">{{label}}</app-item-label>
	@if (value) {
		<app-chip class="service-chip no-events" shrinkable startIcon="paw-sharp" [label]="value.id | serviceName"></app-chip>
	}
	@else {
		<app-item-value class="no-events" [placeholder]="placeholderValue"></app-item-value>
	}
</app-item>
<ion-popover class="popover-menu popover" #popover [isOpen]="popoverIsOpen" [showBackdrop]="false" alignment="end" (didDismiss)="popoverIsOpen = false">
	<ng-template>
		<div class="popover-menu-content">
			<app-item class="hoverable-element" (click)="changeService()">Change</app-item>
			<app-item class="hoverable-element" (click)="clearService()">Clear</app-item>
		</div>
	</ng-template>
</ion-popover>